import { render, staticRenderFns } from "./CardSvg.vue?vue&type=template&id=70a69957&"
import script from "./CardSvg.vue?vue&type=script&lang=js&"
export * from "./CardSvg.vue?vue&type=script&lang=js&"
import style0 from "./CardSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports